import { createFileRoute } from '@tanstack/react-router'
import SupplierDetailsPage from '@/pages/suppliers/SupplierDetailsPage'

export const Route = createFileRoute('/suppliers/$id')({
  component: SupplierDetailsPage,
})
